var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsightEngine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M63.3332 16.6667H16.6665V63.3333H63.3332V16.6667Z",
    fill: "url(#paint0_linear_441_645)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3333 10H16.6667C13 10 10 13 10 16.6667V63.3333C10 67 13 70 16.6667 70H63.3333C67 70 70 67 70 63.3333V16.6667C70 13 67 10 63.3333 10ZM63.3333 63.3333H16.6667V16.6667H63.3333V63.3333Z",
    fill: "url(#paint1_linear_441_645)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0002 40H23.3335V56.6667H30.0002V40Z",
    fill: "url(#paint2_linear_441_645)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6667 23.3333H50V56.6667H56.6667V23.3333Z",
    fill: "url(#paint3_linear_441_645)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3332 46.6667H36.6665V56.6667H43.3332V46.6667Z",
    fill: "url(#paint4_linear_441_645)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3332 33.3333H36.6665V40H43.3332V33.3333Z",
    fill: "url(#paint5_linear_441_645)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_441_645",
    x1: 18.5724,
    y1: 40,
    x2: 61.254,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_441_645",
    x1: 12.4505,
    y1: 40,
    x2: 67.3267,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_441_645",
    x1: 23.6058,
    y1: 48.3333,
    x2: 29.7031,
    y2: 48.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_441_645",
    x1: 50.2723,
    y1: 40,
    x2: 56.3696,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_441_645",
    x1: 36.9388,
    y1: 51.6667,
    x2: 43.0361,
    y2: 51.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_441_645",
    x1: 36.9388,
    y1: 36.6667,
    x2: 43.0361,
    y2: 36.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66D1FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightEngine);
export default __webpack_public_path__ + "static/media/insight-engine.8a0348a6fd9e8746981d910d4ede7a45.svg";
export { ForwardRef as ReactComponent };